import { css } from '@emotion/core';

const anchorPositions = ({ horizontal, vertical }) => {
  let transforms = [];

  if (horizontal === 'left' || horizontal === 'right') {
    transforms.push('translateX(0);');
  } else {
    transforms.push('translateX(-50%);');
  }

  return `
  position: absolute;
  z-index: 2;
${vertical === 'top' ? 'bottom: 65%;' : 'top: 100%;'}
${horizontal !== 'right' && horizontal !== 'left' ? 'left: 50%;' : ''}
${horizontal === 'right' ? 'right: 0;' : ''}
${horizontal === 'left' ? 'left: 0;' : ''}
${transforms ? `transform: ${transforms}` : ''}
`;
};

const styles = ({
  position,
  selectBehavior,
  isDisabled,
  theme,
  searchBehavior,
  isFullWidth
}) => ({
  // fit-content does not work on IE, we need a fallback value
  inputContainer: css`
    width: ${isFullWidth ? '100%' : 'fit-content'};

    & input.vds-input--input-text {
      height: 2.5rem;
      height: calc(2.5rem - 2px);
    }

    ${searchBehavior &&
    `
    & button {
      pointer-events: none;
    }

    .vds-input-bar {
      display: flex;

      .vds-input-input {
        order: 2;
      }

      button {
        order: 1;
      }

      & [class^='vds-icon'] use {
        fill: ${theme?.cybs?.base?.wcag21?.charcoal ?? '#000000'}
      }
    }
    `}

    ${/* dead code?*/ selectBehavior &&
    !isDisabled &&
    `
      &&.vds-input:not() {
        div.vds-input-bar {
          border: 1px solid ${
            theme?.vds?.inputUnderline ?? '#616188'
          } !important;

          input.vds-input--input-text {
            caret-color: transparent;
            color: #000;
            pointer-events: auto;
          }
        }

        &.vds-state--focus  div.vds-input-bar{
          outline: 1px dashed #616188 !important;
        }

        &:hover div.vds-input-bar {
          border: 1px solid ${theme?.cybs?.core?.primary ?? '#1434CB'} !important;
          
          &::before {
            border-bottom: none solid ${theme?.cybs?.core?.primary ?? '#1434CB'} !important;
          }
        }
      }
    `}
  `,
  menuContainer: css`
    position: relative;
    width: ${isFullWidth ? '100%' : 'fit-content'};
    height: fit-content;

    .vds-listbox-item {
      word-break: break-all;

      &.vds-state--focus {
        outline: 1px dashed ${theme?.vds?.buttonSecondaryTextBorder ?? '#1434CB'};
        outline-offset: -2px;
      }

      &.vds-state--selected > span {
        padding-right: 2rem;
      }

      .vds-checkbox-label {
        &::after {
          border: 2px solid ${theme?.cybs?.core?.primary ?? '#1434CB'};
        }
        &.vds-state--checked::after {
          background-color: ${theme?.vds?.radioBackgroundChecked ?? '#1434CB'};
        }
      }
    }

    .vds-state--disabled:not(.cybs-listbox-item-section) {
      color: ${theme?.cybs?.base?.wcag21?.charcoal ?? '#000000'} !important;
    }
  `,
  menuWrapper: css`
    ${position ? anchorPositions(position) : ''}
    width: ${isFullWidth ? '100%' : 'fit-content'};
    height: fit-content;
  `
});

export default styles;
